// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"6e3ae5df","433":"63202666"}[chunkId] + ".chunk.js";
};